import { Link } from "react-router-dom";
import SectionHeading from "@/components/base/SectionHeading";
import { hotRanking, events } from "@/mocks/gossip";

const maxHeat = Math.max(...hotRanking.map((r) => r.heat));

export default function RankSection() {
  return (
    <section className="w-full bg-foreground-950 py-14 md:py-20">
      <div className="w-full px-4 md:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10">
          <div className="lg:col-span-4">
            <span className="inline-flex items-center gap-2 font-label text-xs tracking-[0.25em] text-accent-400 uppercase">
              <span className="w-6 h-px bg-accent-400"></span>
              热度榜单
            </span>
            <h2 className="mt-3 font-heading font-bold text-2xl md:text-[32px] leading-tight text-background-50">
              本周被翻得最多的复盘
            </h2>
            <p className="mt-3 font-label text-sm md:text-[15px] leading-relaxed text-background-300">
              热度由阅读、点赞与讨论量综合计算。榜单每天更新一次，只反映关注度，不代表任何立场。
            </p>
          </div>

          <div className="lg:col-span-8">
            <ol className="space-y-3">
              {hotRanking.map((r) => {
                const ev = events.find((e) => e.id === r.id);
                const pct = Math.round((r.heat / maxHeat) * 100);
                return (
                  <li key={r.id}>
                    <Link
                      to={`/event/${r.id}`}
                      className="group flex items-center gap-4 rounded-lg border border-background-800 bg-background-900/50 p-4 hover:border-accent-500/60 transition-colors cursor-pointer"
                    >
                      <span
                        className={`w-10 h-10 shrink-0 flex items-center justify-center rounded-md font-heading font-bold text-lg ${
                          r.rank <= 3 ? "bg-accent-500 text-accent-950" : "bg-background-800 text-background-200"
                        }`}
                      >
                        {r.rank}
                      </span>
                      <span className="min-w-0 flex-1">
                        <span className="flex flex-wrap items-center gap-2">
                          <span className="font-heading font-semibold text-[15px] md:text-base text-background-50 group-hover:text-accent-300 transition-colors">
                            {r.title}
                          </span>
                          <span className="rounded-full bg-background-800 px-2 py-0.5 font-label text-[10px] text-background-300">
                            {ev?.category}
                          </span>
                        </span>
                        <span className="mt-2 block h-1.5 w-full overflow-hidden rounded-full bg-background-800">
                          <span
                            className="block h-full rounded-full bg-gradient-to-r from-primary-500 to-accent-500"
                            style={{ width: `${pct}%` }}
                          ></span>
                        </span>
                      </span>
                      <span className="hidden sm:flex shrink-0 items-center gap-1.5 font-label text-sm text-accent-400">
                        <i className="ri-fire-line"></i>
                        {r.heat}
                      </span>
                    </Link>
                  </li>
                );
              })}
            </ol>
          </div>
        </div>
      </div>
    </section>
  );
}